module.exports = __webpack_public_path__ + "img/LIST.b93bf5e0.svg";